import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';
import { responsibilityNotice } from '../copy';

const StyledStructuredTaskSmallPrint = styled(Typography)<{ $marginTop?: string }>`
  margin-top: ${({ $marginTop }) => $marginTop};
`;

export type StructuredTaskSmallPrintProps = {
  marginTop?: string;
  customCopy?: string;
};

/**
 * A notice that appears at the bottom of structured task pages regarding the prescribing licensed healthcare provider's
 * responsibility for the accuracy of the information.
 */
export const BusinessRelationshipSmallPrint = ({ marginTop = '16px', customCopy }: StructuredTaskSmallPrintProps) => {
  return (
    <StyledStructuredTaskSmallPrint $marginTop={marginTop} styledAs="bodyExtraSmallDMSans" color="var(--grayscale-600)">
      {customCopy || <>{responsibilityNotice}</>}
    </StyledStructuredTaskSmallPrint>
  );
};

export default BusinessRelationshipSmallPrint;
